<template>
  <portal to="modal">
    <transition name="from-right">
      <div class="shop-locations-wrapper" v-if="this.$store.state.main.shopLocationActive">
        <div class="close-wrapper">
          <svg
            id="j-logo-modal"
            xmlns="http://www.w3.org/2000/svg"
            width="59.999"
            height="60"
            viewBox="0 0 59.999 60"
          >
            <g
              id="Group_99"
              data-name="Group 99"
              transform="translate(-692.335 -235.632)"
            >
              <path
                id="Path_211"
                data-name="Path 211"
                d="M748.311,250.636a29.994,29.994,0,1,1-40.973-10.981,29.993,29.993,0,0,1,40.973,10.981"
                transform="translate(0 0)"
                fill="#bacb32"
                fill-rule="evenodd"
              />
              <path
                id="Path_212"
                data-name="Path 212"
                d="M725.648,278.672c-2.532,1.462-5.039.905-6.223-1.146-1.027-1.779-.725-3.777.369-4.409a.95.95,0,0,1,1.216.21,2.87,2.87,0,0,0-.122,3.263,2.258,2.258,0,0,0,3.3.826c2.53-1.461,1.953-4.044.184-7.581-4.062-8.141-9.117-17.53-10.815-20.47a15.3,15.3,0,0,1-2.967,7.181c2.469-.147,4.782.7,5.652,2.209,1.381,2.392.248,4.692-1.806,5.877-1.64.947-3.671.748-4.618-.892a2.106,2.106,0,0,1,.713-2.873c.718.77,1.691,1.668,3.2.8a1.417,1.417,0,0,0,.519-1.943c-.829-1.435-2.859-1.634-4.561-1.741a1.208,1.208,0,0,1-.955-.544c-.2-.342-.149-.736.242-1.325,4-5.86,2.291-8.346,4.754-9.767,1.982-1.144,3.652,1.9,4.785,3.711,1.571,2.558,4.7,8.137,8.762,16.279,2.254,4.535,3.908,9.139-1.629,12.336"
                transform="translate(3.137 2.015)"
                fill="#101820"
              />
            </g>
          </svg>

          <div class="close-btn" @click="openShopLocations()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26.469"
              height="27.766"
              viewBox="0 0 26.469 27.766"
            >
              <g
                id="Group_240"
                data-name="Group 240"
                transform="translate(-1721.922 -107.326)"
              >
                <path
                  id="Path_1643"
                  data-name="Path 1643"
                  d="M1.327,4.6c5.967.11,11.824-1.074,17.777-1.2,3.641-.077,7.6.437,11.16-.633.884-.266,1.97-.777,1.935-1.837l0-.129C32.16-.223,30.251-.187,28.922.468c-3.236.742-6.913.076-10.173.249C13.5,1,8.309,1.961,3.043,1.863,1.23,1.831-1.742,4.544,1.327,4.6Z"
                  transform="translate(1725.181 107.326) rotate(45)"
                  fill="#101820"
                />
                <path
                  id="Path_1644"
                  data-name="Path 1644"
                  d="M29.1.291c-3.635,1.787-8.026,1.644-11.979,1.44A123.652,123.652,0,0,1,3.008.37C.8,0-1.6,3.126,1.433,3.635A110.5,110.5,0,0,0,18.464,5.1c4.3.045,8.71-.245,12.631-2.173C33.875,1.564,31.384-.833,29.1.291Z"
                  transform="translate(1721.922 131.48) rotate(-45)"
                  fill="#101820"
                />
              </g>
            </svg>

            <span class="f-21 regular">
              {{$fn.tr('დახურვა')}}
            </span>
          </div>
        </div>

        <h2 class="f-34">{{$fn.tr('მაღაზიები')}}</h2>

        <div class="tabs-container">

                  <swiper ref="mySwiper" :options="swiperOptions" class="vue-tablist">

                      <div  title="ყველა" :class="{active: activeTab == 'ყველა'}" class="vue-tab swiper-slide" @click="selectTab($event)">{{$fn.tr('ყველა')}}</div>
                      <div :title="sh" :class="{active: activeTab == sh}" class="vue-tab swiper-slide" @click="selectTab($event)" v-for="(sh, index) in this.cities" :key="index">{{sh}}</div>
                      </swiper>          

                    <div class="vue-tabpanel-wrapper">          
                    <div v-show="activeTab == 'ყველა'"  class="vue-tabpanel"> 
                         <div v-for="(all, index) in getAllShops" :key="index" class="loc-row">
                            <div class="city-wrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.081" height="18" viewBox="0 0 15.081 18">
  <g id="fi-rr-marker" transform="translate(-1.945 0.002)">
    <g id="Group_2211" data-name="Group 2211" transform="translate(1.945 -0.002)">
      <path id="Path_3914" data-name="Path 3914" d="M11,6a3,3,0,1,0,3,3A3,3,0,0,0,11,6Zm0,4.5A1.5,1.5,0,1,1,12.5,9,1.5,1.5,0,0,1,11,10.5Z" transform="translate(-3.459 -1.499)" fill="#101820"/>
      <path id="Path_3915" data-name="Path 3915" d="M9.486,18a3.953,3.953,0,0,1-3.233-1.65C3.395,12.406,1.945,9.442,1.945,7.539a7.541,7.541,0,1,1,15.081,0c0,1.9-1.45,4.867-4.308,8.809A3.953,3.953,0,0,1,9.486,18Zm0-16.363a5.912,5.912,0,0,0-5.9,5.9c0,1.507,1.42,4.295,4,7.849a2.359,2.359,0,0,0,3.817,0c2.577-3.554,4-6.341,4-7.849a5.912,5.912,0,0,0-5.9-5.9Z" transform="translate(-1.945 0.002)" fill="#101820"/>
    </g>
  </g>
</svg>

                        <span class="f-16 light-italic">{{ all.title }}</span>  

</div>
                        <div class="right-col-wrapper">
                         <span  class="f-16 bold-italic shop-name">{{ all.shop }}</span>   
                         <span  class="f-16 light-italic">{{ all.address }}</span>   
                         </div>


                        </div> 
                    </div>

                    <div v-show="activeTab == sh.city" v-for="(sh, index) in shops2" :key="index" class="vue-tabpanel">
                          
                        <div v-for="(loc, index) in sh.locations" :key="index" class="loc-row">
                            <div class="city-wrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.081" height="18" viewBox="0 0 15.081 18">
  <g id="fi-rr-marker" transform="translate(-1.945 0.002)">
    <g id="Group_2211" data-name="Group 2211" transform="translate(1.945 -0.002)">
      <path id="Path_3914" data-name="Path 3914" d="M11,6a3,3,0,1,0,3,3A3,3,0,0,0,11,6Zm0,4.5A1.5,1.5,0,1,1,12.5,9,1.5,1.5,0,0,1,11,10.5Z" transform="translate(-3.459 -1.499)" fill="#101820"/>
      <path id="Path_3915" data-name="Path 3915" d="M9.486,18a3.953,3.953,0,0,1-3.233-1.65C3.395,12.406,1.945,9.442,1.945,7.539a7.541,7.541,0,1,1,15.081,0c0,1.9-1.45,4.867-4.308,8.809A3.953,3.953,0,0,1,9.486,18Zm0-16.363a5.912,5.912,0,0,0-5.9,5.9c0,1.507,1.42,4.295,4,7.849a2.359,2.359,0,0,0,3.817,0c2.577-3.554,4-6.341,4-7.849a5.912,5.912,0,0,0-5.9-5.9Z" transform="translate(-1.945 0.002)" fill="#101820"/>
    </g>
  </g>
</svg>

                        <span class="f-16 light-italic">{{ sh.city }}</span>  

</div>
                        <div class="right-col-wrapper">
                         <span  class="f-16 bold-italic shop-name">{{ loc.shop }}</span>   
                         <span  class="f-16 light-italic">{{ loc.address }}</span>   
                         </div>


                        </div>
                    </div>
                  </div>  
                
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>

export default {
 
  data() {
    return {
      activeTab: null,
         swiperOptions: {
           slidesPerView: "auto",
           watchOverflow: true,

        },
        allShops: [],
        cities: [],
      // shops: [
      //   {
      //     city: "თბილისი",
      //     locations: [
      //       {
      //         shop: "ნიკორა",
      //         address: "მარშალ გელოვანის 58"
      //       },
      //       {
      //         shop: "გუდვილი ვაკე",
      //         address: "ჭავჭავაძის 27"
      //       },
      //       {
      //         shop: "კარფური ისთ ფოინთი",
      //         address: "ვაჟა-ფშაველას 7"
      //       },
      //       {
      //         shop: "სმარტი",
      //         address: "მარშალ გელოვანის 58"
      //       }
      //     ]
      //   },

      //   {
      //     city: "ქუთაისი",
      //     locations: [
      //       {
      //         shop: "სმარტი",
      //         address: "ვაჟა-ფშაველას 7"
      //       },
      //       {
      //         shop: "ევროპროდუქტი",
      //         address: "მარშალ გელოვანის 58"
      //       }
      //     ]
      //   },


      //     {
      //     city: "რუსთავი",
      //     locations: [
      //       {
      //         shop: "ალკორიუმი",
      //         address: "ვაჟა-ფშაველას 7"
      //       },
      //       {
      //         shop: "კარფური ისთ ფოინთი",
      //         address: "მარშალ გელოვანის 58"
      //       }
      //     ]
      //   },

      //    {
      //     city: "ბათუმი",
      //     locations: [
      //       {
      //         shop: "გუდვილი",
      //         address: "ვაჟა-ფშაველას 7"
      //       },
      //       {
      //         shop: "კარფური ისთ ფოინთი",
      //         address: "მარშალ გელოვანის 58"
      //       },
      //        {
      //         shop: "კარფური ისთ ფოინთი",
      //         address: "ლეონიძის 58"
      //       }
      //     ]
      //   },
      // ]
    };
  },
      computed:{
        shops(){
          let shops = [];
          return this.$store.state.main.indx.terms.shops;
        },
         shops2(){
          let shops = [];
          let shops2 = [];
          let cities = [];
           Object.keys(this.shops).forEach(shop => {
             cities.push(shop)
             
           })

        for (let i = 0; i < cities.length; i++) {
          let c = {
            city: cities[i],
            locations: []
          }
          shops.push(c)
          
        }
         
          Object.values(this.shops).forEach(shop => {
            for (let i = 0; i < shop.length; i++) {
                    let  sh = {
              city: shop[i].title,
              locations: [
                {
                  shop: shop[i].shop,
                  address: shop[i].address,
                }
              ]
            }
            
            shops2.push(sh);
              
            }
           })
            for (let i = 0; i < shops.length; i++) {
            shops2.forEach(it => {
              if(it.city == shops[i].city){
                console.log(it.locations)
                 let sh = {
                   shop: it.locations[0].shop,
                   address: it.locations[0].address
                 }
                shops[i].locations.push(sh)
              }
            });
           
            
            
          }
           console.log(shops2)
          return shops;
        },
      shopLocationsStatus(){
          return this.$store.state.main.shopLocationActive;
      },

      getAllShops(){
          let allCat = [];
          // let cities = [];
          let locations = [];
           Object.keys(this.shops).forEach(shop => {
             this.cities.push(shop)
           })
          Object.values(this.shops).forEach(shop => {
            for (let i = 0; i < shop.length; i++) {
                allCat.push(shop[i])
                
            }
           locations.push(shop)
           
          console.log(shop)
               
          })
          
         console.log(this.cities)
          //      for (let i = 0; i < locations.length; i++) {
          //         let concated = Object.assign(locations[i], {title: `${cities[i]}`})
          //         allCat.push(concated);   
          //       for (let j = 0; j < locations[i].length; j++) {
          //         //  let concated = Object.assign(locations[i][j], {title: `${cities[i]}`})
          //         //  allCat.push(concated);   
          //       }
                   
                 

            
               
          //  }
              
          
         console.log(allCat)
       
          return allCat;
          
      }
  },
 mounted(){
      this.activeTab = 'ყველა';
     

      console.log(this.shops2)
  },
  methods: {
       openShopLocations() {
      this.$store.commit("main/shopLocationsStatus", !this.$store.state.main.shopLocationActive);

      
    },

    selectTab(e){
      let ttl = e.currentTarget.title;
    //  console.log(e.currentTarget.title);
      this.activeTab = ttl;
      console.log( e.currentTarget)
      console.log(this.activeTab)


    }
  },
 
};
</script>

<style lang="scss">
.shop-locations-wrapper{
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 690px;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 34px;
    padding-bottom: 34px;
    z-index: 9999;
    background-color: white;
    .vue-tablist{
        display: flex;
        width: 100%;
      
        padding-bottom: 21.5px;
        border-bottom: 1px solid #101820;
        margin-bottom: 22px;
    }
    .swiper-slide{
      width: auto !important;
    }
    .tabs-container{
      position: relative;
    }
    .vue-tab{
        width: fit-content;
        font-size: 21px;
        margin-right: 34px;
          font-family: "FiraGO-Italic";
          cursor: pointer;
          color: rgba(16, 24, 32, 0.5);
          &.active{
                 font-family: "FiraGO-BoldItalic";
                 color: #101820;
          }
    }

  .vue-tabpanel-wrapper{
    position: relative;
     padding-right: 5px;
      overflow-y: auto;
    overflow-x: hidden;
    // height: 100%;
     // height: 900px;
       &::-webkit-scrollbar{
      position: absolute;
      right: 0;
      top: 0;
      width: 5px;
    }
    &::-webkit-scrollbar-track{
      background-color: white;
    }
    &::-webkit-scrollbar-thumb{
      background-color: #044B30;
      border-radius: 10px;
    }
       
  
  }
    .vue-tabpanel{
        display: flex;
        flex-direction: column;
     // height: 100%;
     height: 60vh;
     .city-wrapper{
            display: flex;
            svg{
                margin-right: 10.1px;
            }
            margin-right: 97.8px;
        }
        .right-col-wrapper{
            display: flex;
            justify-content: space-between;
            width: 100%;
        }
        .loc-row{
            display: flex;
            //justify-content: space-between;
            padding-bottom: 13.5px;
            padding-top: 12.5px;
            border-bottom: 1px solid rgba(58, 90, 167, 0.3);
        }
    }
    h2{
        color: #BACB32;
        margin-bottom: 55px;
    }
    .close-wrapper{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 55px;
    }
    .close-btn{
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: .4s;
        @media (min-width: 1024px){
            &:hover{
                transform: scale(1.1) rotate(-2deg);
            }
        }
        svg{
            margin-right: 9.6px;
        }
    }

@media (max-width: 767px){
    width: 100%;
    padding-left: 17px;
    padding-right: 17px;
     .vue-tabpanel {
         span{
             font-size: 13px;
         }
          .city-wrapper{
         margin-right: 20px;
     }
     }
    
}

@media (max-width: 570px){
  .vue-tabpanel .right-col-wrapper{
    span{
      &:nth-child(1){
        width: 100px;
      }
    }
  }
}

@media (max-width: 413px){
  .vue-tabpanel .right-col-wrapper span:nth-child(1){
   // max-width: 50px;
    width: fit-content;
    max-width: 100px;
  }
  .vue-tabpanel span{
    font-size: 10px;
  }
 .vue-tabpanel .loc-row{
   .city-wrapper{
     margin-right: 10px;
   }
 }
}



@media (max-height: 840px){
  .vue-tabpanel{
    height: 50vh;
  }
}
@media (max-height: 670px){
  .vue-tabpanel{
    height: 45vh;
  }
}

@media (max-height: 595px){
  .vue-tabpanel{
    height: 38vh;
  }
}
@media (max-height: 535px){
  .vue-tabpanel{
    height: 30vh;
  }
}
}
.from-right-enter-active,
.from-right-leave-active {
  transition: all 0.7s cubic-bezier(0.33, 1, 0.68, 1);
}
.from-right-enter{
    transform: translateX(100%);
}
.from-right-leave-to {
  transform: translateX(100%);
}
</style>
